// @ts-nocheck
import api from "./api";
const URLS = {
  PATIENT_REFERRAL: "/patient-navigation",
  REPORT_PATIENT_REFERRAL: "/report/patient-navigation",
};

export const fetchPatientNavigation = (data) => {
  return api.get(URLS.PATIENT_REFERRAL, data);
};

export const createPatientReferral = (data = {}) => {
  return api.post(URLS.PATIENT_REFERRAL, data);
};

export const fetchPatientNavigationReferralById = (id, data) => {
  return api.get(URLS.PATIENT_REFERRAL + "/" + id, data);
};
export const patchPatientNavigationReferralById = (id, data) => {
  return api.patch(URLS.PATIENT_REFERRAL + "/" + id, data);
};

export const createPatientNavigationReferralNote = (data = {}) => {
  return api.post(URLS.PATIENT_REFERRAL + "/notes", data);
};

export const createPatientNavigationReferralFollowUp = (id, data = {}) => {
  return api.post(URLS.PATIENT_REFERRAL + "/" + id + "/follow-up", data);
};

export const fetchPatientNavigationReferralFollowUps = (id, data) => {
  return api.get(URLS.PATIENT_REFERRAL + "/" + id + "/follow-up", data);
};

export const reschedulePatientNavigation = (id, data = {}) => {
  return api.post(URLS.PATIENT_REFERRAL + "/" + id + "/reschedule", data);
};

export const getPatientNavigationReferral = (id, data = {}) => {
  return api.get(URLS.PATIENT_REFERRAL + "/" + id, data);
};

export const getOverallPatientNavigationReport = (params) => {
  return api.get(URLS.REPORT_PATIENT_REFERRAL + "/overall", { params });
};

export const getFullPatientNavigationReport = (params) => {
  return api.get(URLS.REPORT_PATIENT_REFERRAL + "/full", { params });
};
